import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import CTALinks from 'components/CTALinks';
import { Container, Grid, Cell } from 'components/Grid';
import { SecondaryHeading } from 'components/Headings';
import Paragraph from 'components/Paragraph';
import { mediumUp, largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const SecondaryPromoHeroPanel = ({ heading, subheading, ctaLinks, onCTAClick, isInverted }) => (
  <div
    className={classNames('HomepageV2SecondaryPromoHero__panel', {
      'HomepageV2SecondaryPromoHero__panel--inverted': isInverted,
    })}
  >
    <Container>
      <Grid isCentered>
        <Cell small={{ columns: 12 }} medium={{ columns: 10 }} largeUp={{ columns: 6 }}>
          <div className="HomepageV2SecondaryPromoHero__panel-content">
            <SecondaryHeading>{heading}</SecondaryHeading>
            {subheading && <Paragraph>{subheading}</Paragraph>}
            <CTALinks
              className="HomepageV2SecondaryPromoHero__cta-links"
              links={ctaLinks}
              onClick={onCTAClick}
            />
          </div>
        </Cell>
      </Grid>
    </Container>
    <style jsx>
      {`
        .HomepageV2SecondaryPromoHero__panel {
          margin-top: ${Theme.get('spacing') * 4}px;
          background-color: ${Theme.get('colors-white')};
        }

        .HomepageV2SecondaryPromoHero__panel--inverted {
          background-color: ${Theme.get('colors-black')};
        }

        @media ${mediumUp} {
          .HomepageV2SecondaryPromoHero__panel {
            margin-top: ${Theme.get('spacing') * 6}px;
          }
        }

        @media ${largeUp} {
          .HomepageV2SecondaryPromoHero__panel {
            margin-top: ${Theme.get('spacing') * 8}px;
          }
        }
      `}
    </style>
    <style jsx global>
      {`
        .HomepageV2SecondaryPromoHero__panel .Container {
          overflow-x: hidden;
        }

        .HomepageV2SecondaryPromoHero__panel-content {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          width: 100%;
        }

        .HomepageV2SecondaryPromoHero__panel h2.typography--secondary-heading,
        .HomepageV2SecondaryPromoHero__panel p.Paragraph {
          text-align: center;
          margin-bottom: ${Theme.get('spacing') * 2}px;
          min-width: 100%;
        }

        .HomepageV2SecondaryPromoHero__panel--inverted h2.typography--secondary-heading,
        .HomepageV2SecondaryPromoHero__panel--inverted p.Paragraph {
          color: ${Theme.get('colors-white')};
        }

        @media ${mediumUp} {
          .HomepageV2SecondaryPromoHero__panel h2.typography--secondary-heading,
          .HomepageV2SecondaryPromoHero__panel p.Paragraph {
            margin-bottom: ${Theme.get('spacing') * 3}px;
          }
        }

        .HomepageV2SecondaryPromoHero__panel .HomepageV2SecondaryPromoHero__cta-links {
          margin-top: ${Theme.get('spacing') * 2}px;
        }
      `}
    </style>
  </div>
);

SecondaryPromoHeroPanel.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  ctaLinks: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, linkUrl: PropTypes.string })
  ).isRequired,
  onCTAClick: PropTypes.func,
  isInverted: PropTypes.bool,
};

SecondaryPromoHeroPanel.defaultProps = {
  onCTAClick: () => {},
  isInverted: false,
};

export default SecondaryPromoHeroPanel;
